import React, { useContext } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import ImageLight from "../assets/img/login-office.jpeg";
import ImageDark from "../assets/img/login-office-dark.jpeg";
import Atenea from "../assets/img/atenea.jpg";
import { GithubIcon, TwitterIcon } from "../icons";
import { Label, Input, Button } from "@windmill/react-ui";
import { jwtDecode } from "jwt-decode";
import { SidebarContext } from "../context/SidebarContext";
const { REACT_APP_LOGIN } = process.env;
export function LogIt(data) {
  const pars = useParams();

  console.log(pars);
  sessionStorage.setItem("token", pars.token);
  window.location.href = "/";
}

function LoginDEPRECATED() {
  const navigate = useNavigate();
  const sidebarContext = useContext(SidebarContext);

  function log(e) {
    e.preventDefault();
    /*     console.log(REACT_APP_BOOKS)
     */ const formData = new FormData(e.target);
    /* const resp = Array.from(formData.entries()).reduce((prev, [name, value]) => {
        return { ...prev, [name]: value };
    }, {});

    console.log(resp)
    var formdata=new FormData()
    formd */

    fetch(REACT_APP_LOGIN, {
      method: "post",
      body: formData,
    })
      .then((r) => r.json())
      .then((r) => {
        sessionStorage.setItem("token", r.token);
        window.location.href = "/";
      })
      .catch((e) => console.log(e));
  }

  return (
    <div className="flex items-center min-h-screen p-6 bg-gray-50 dark:bg-gray-900">
      <div className="flex-1 h-full max-w-4xl mx-auto overflow-hidden bg-white rounded-lg shadow-xl dark:bg-gray-800">
        <form onSubmit={log}>
          <div className="flex flex-col overflow-y-auto md:flex-row">
            <div className="h-32 md:h-auto md:w-1/2">
              <img
                aria-hidden="true"
                className="object-cover w-full h-full dark:hidden"
                src={ImageLight}
                alt="Office"
              />
              <img
                aria-hidden="true"
                className="hidden object-cover w-full h-full dark:block"
                src={ImageDark}
                alt="Office"
              />
            </div>
            <main className="flex items-center justify-center p-6 sm:p-12 md:w-1/2">
              <div className="w-full">
                <h1 className="mb-4 text-xl font-semibold text-gray-700 dark:text-gray-200">
                  Login
                </h1>
                <Label>
                  <span>EMAIL</span>
                  <Input
                    className="mt-1"
                    type="text"
                    name="username"
                    placeholder="correo electrónico"
                  />
                </Label>

                <Label className="mt-4">
                  <span>PASSWORD</span>
                  <Input
                    className="mt-1"
                    type="password"
                    name="password"
                    placeholder="Contraseña"
                  />
                </Label>

                <Button type="submit" className="mt-4" block>
                  Ingresar
                </Button>

                <hr className="my-8" />
                {/* 
              <Button block layout="outline">
                <GithubIcon className="w-4 h-4 mr-2" aria-hidden="true" />
                Github
              </Button>
              <Button className="mt-4" block layout="outline">
                <TwitterIcon className="w-4 h-4 mr-2" aria-hidden="true" />
                Twitter
              </Button> */}

                <p className="mt-4">
                  <Link
                    className="text-sm font-medium text-purple-600 dark:text-purple-400 hover:underline"
                    to="/forgot-password"
                  >
                    Recuperar contraseña?
                  </Link>
                </p>
                <p className="mt-1">
                  <Link
                    className="text-sm font-medium text-purple-600 dark:text-purple-400 hover:underline"
                    to="/create-account"
                  >
                    Crear cuenta
                  </Link>
                </p>
              </div>
            </main>
          </div>
        </form>
      </div>
    </div>
  );
}

function Login(params) {
  return ( <div className="h-screen content-center justify-center">
    <section class="bg-white dark:bg-gray-900">
      <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div class="mx-auto max-w-screen-sm text-center">
          <div class=" m-15">
            <div
              class={`w-48 h-48 bg-indigo-100 mx-auto rounded-full shadow-2xl  inset-x-0  -mt-24 flex items-center justify-center text-indigo-500 ${
                "overflow-hidden"
              }`}
            >
              <img src={Atenea} alt="bookCover" />
            </div>
          </div>
          <p class="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl dark:text-white">
            Parece que no estás logeado.
          </p>
          <p class="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">
            Los usuarios deben logearse en el sistema Atenea antes de acceder a biblioteca.{" "}
          </p>
          <a
            href="https://atenea.instipp.edu.ec"
            class="inline-flex text-black bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-primary-900 my-4"
          >
            IR A ATENEA
          </a>
        </div>
      </div>
    </section>
  </div>

  );
  {
    /* <div>
    Para ingresar al sistema debe logearse en atenea

    <a href="https://atenea.instipp.edu.ec" target="_blank">Ir a Google</a>
  </div> */
  }
}
export default Login;
